/** Deterministic fitting also works when rendering SVGs without a browser DOM. */
export function fitSvgLabel(text: string, availableWidth: number, fontSize: number) {
  const width = Math.max(0, availableWidth);
  const characters = Array.from(text.replace(/\s+/g, " ").trim());
  const advance = (character: string) => fontSize * (
    /[ilI1 .,:;'!|]/.test(character) ? 0.32 : /[MWmw@%]/.test(character) ? 0.9
      : character.codePointAt(0)! > 255 ? 1 : 0.62);
  const fullWidth = characters.reduce((sum, character) => sum + advance(character), 0);
  if (fullWidth <= width) return { text: characters.join(""), width: fullWidth };
  const ellipsisWidth = fontSize;
  if (width < ellipsisWidth) return { text: "", width: 0 };
  let used = 0;
  let shortened = "";
  for (const character of characters) {
    if (used + advance(character) + ellipsisWidth > width) break;
    shortened += character;
    used += advance(character);
  }
  return { text: `${shortened.trimEnd()}…`, width: Math.min(width, used + ellipsisWidth) };
}
